import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { MDBCard, MDBCardBody, MDBCardImage, MDBRow, MDBCol } from "mdbreact";

import Like from "../../../../assets/images/Icons/Links/Heart Fill.svg";
import ChatDots from "../../../../assets/images/Icons/Links/Annotation.svg";
import Share from "../../../../assets/images/Icons/Links/Share.svg";
import Doctor from "../../../../assets/images/Icons/Doctor.svg";
import Photograph from "../../../../assets/images/Icons/Links/Photograph.svg";
import Send from "../../../../assets/images/Icons/Links/Send.svg";

import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

interface PostItemProps {
  Name: string;
  Profile: any;
  PostTime: string;
  PostText?: string;
  PostImage?: any;
}

const PostItem = (props: PostItemProps) => {
  return (
    <MDBCard className="mt-3">
      <MDBCardBody>
        <section>
          <img src={props.Profile} alt={props.Name} />
          <div className="mr-2 float-right">
            <h6>{props.Name}</h6>
            <p>{props.PostTime}</p>
          </div>
          <span>
            <FontAwesomeIcon
              icon={faEllipsisV}
              className="d-inline-inline mx-2"
            />{" "}
          </span>
        </section>
        {props.PostText && <p className="pb-2">{props.PostText}</p>}
        {props.PostImage && (
          <MDBCardImage className="img-fluid" src={props.PostImage} waves />
        )}
        <MDBRow className="footer">
          <MDBCol className="text-right p-0" size={"12"}>
            <img src={Like} className="d-inline-inline" />
            <span>اعجبني</span>

            <img src={ChatDots} className="d-inline-inline mr-2" />
            <span>تعليق</span>

            <img src={Share} className="d-inline-inline mr-2" />
            <span>مشاركة</span>
          </MDBCol>
          <MDBCol size={"12"} className="my-3 p-0">
            <MDBCard className="comment">
              <MDBCardBody>
                <img src={Doctor} alt="Doctor" />
                <p className="mr-3">ماذا يدور في ذهنك مصطفى؟</p>
                <div className="mr-auto icon">
                  <img src={Photograph} className="ml-3" />
                  <img src={Send} />
                </div>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBCardBody>
    </MDBCard>
  );
};

export default PostItem;
